import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {isMobile} from 'react-device-detect';

class SiteMenu extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            selectedCategory: null
        };
        this.menuItemlink = this.menuItemlink.bind(this);
        this.categoryFilter = this.categoryFilter.bind(this);
        this.mouseOver = this.mouseOver.bind(this);
    }

    categoryFilter(e) {
        if(e.currentTarget.getAttribute('data-category') === this.state.selectedCategory){
            this.setState({
                selectedCategory: null
            });
            document.getElementsByClassName('menu')[0].id = "";
        } else {
            this.setState({
                selectedCategory: e.currentTarget.getAttribute('data-category')
            });
            document.getElementsByClassName('menu')[0].id = "filtered";
        }

    }

    menuItemlink(e){        
        var targetSlide = e.currentTarget.getAttribute('data-post');  
        //load 2 of target post images
        if( this.props.nodes[targetSlide].fields.imageGallery !== undefined){
            let images = this.props.nodes[targetSlide].fields.imageGallery;
            for(var i = 0; i < 2; i++) {
                const img = new Image();
                img.src = images[i].fields.file.url+'?q=90&w=1400';
            }
        }
        this.props.menuClickHandler(targetSlide, true);
    }

    mouseOver(e) {
        if(!isMobile){
            var targetSlide = e.currentTarget.getAttribute('data-post');  
            this.props.menuClickHandler(targetSlide, false);
        }
    }

    render(){
        return (
            <div className="menuParent" style={{ width: "100vw", minHeight: "100%", position: "fixed", zIndex: "20", overflowY: "scroll", top:"0"}}>
                <nav className="catMenu">
                    <ul>
                        {this.props.catMenu &&
                            this.props.catMenu.map((cat, index) => {
                            return (
                                <li className={ this.state.selectedCategory === cat ? "catItem open menuTriggerInner" : "catItem menuTriggerInner"} key={index} data-category={cat} onClick={this.categoryFilter} >{cat}</li>
                            );
                            })}
                    </ul>
                </nav>

                <nav className="menu" style={{ width: "100%", minHeight: "92%", padding: "5% 0 2% 0"}}>
                    <ul>
                        {this.props.nodes &&
                            this.props.nodes.map((node, index) => {
                            let classes;
                            if(this.state.selectedCategory === node.fields.category && this.state.selectedCategory !== null){
                                classes = "menu-item categorySelected";
                            } else {
                                classes = "menu-item";
                            }
                            return (
                                <Link
                                    key={node.sys.id}
                                    to={{
                                        pathname: `/${node.fields.slug}`
                                    }}
                                    data-post={index}
                                    onClick={this.menuItemlink}
                                    onMouseOver={this.mouseOver}
                                    >
                                    { node.fields.imageGallery !== undefined ?  <li className={classes} key={node.sys.id}>{node.fields.title}<span>{node.fields.imageGallery.length}</span></li>:  <li className={classes} key={node.sys.id}>{node.fields.title}</li> }
                                    
                                </Link>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        )
    }
}


export default SiteMenu;


// WEBPACK FOOTER //
// ./src/SiteMenu.js